import {createStyles, TableBody, TableCell, TableRow, Theme, withStyles} from "@material-ui/core";
import {ContractItem} from "../AllContracts/AllContracts";
import {NavLink} from "react-router-dom";
import dateFormatting from "../../scripts/dateFormatting";

export const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        }
    }),
)(TableCell);

export const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }),
)(TableRow);

type ContractsTableBodyProps = {
    data: ContractItem[],
    hiddenRows?: string[],
}

export const ContractsTableBody = (props: ContractsTableBodyProps) => {
    const { data, hiddenRows } = props;

    const openLink = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    return (
        <TableBody>
            {data && data.map((caseItem) => (
                <StyledTableRow key={caseItem.id}>
                    <StyledTableCell component="th" scope="row"> <NavLink to={`contract-page?${caseItem.id}`} onClick={openLink}>{caseItem.caseId || '--unset--'}</NavLink> </StyledTableCell>
                    <StyledTableCell align="center">{dateFormatting(caseItem.statusDateChange)}</StyledTableCell>
                    <StyledTableCell align="center">{caseItem.contractStatus}</StyledTableCell>
                    <StyledTableCell align="center">{caseItem.totalDue ? "$" + caseItem.totalDue : ""}</StyledTableCell>
                    {
                        !hiddenRows?.includes('currentContractRiskRatePercent') && (
                            <StyledTableCell align="center">
                                {Math.round(caseItem?.currentContractRiskRatePercent * 100) + "%"}
                            </StyledTableCell>
                        )
                    }
                    <StyledTableCell align="center">{caseItem.daysBeforePriceIncrease && caseItem.daysBeforePriceIncrease !== 0 && caseItem.daysBeforePriceIncrease + " days left"}</StyledTableCell>
                    <StyledTableCell align="center">${caseItem.paidOff}</StyledTableCell>
                    <StyledTableCell align="center">
                        <NavLink to={`user-profile?${caseItem.contractClientId}`} onClick={openLink} >
                            {caseItem.contractClientFirstName + " " + caseItem.contractClientLastName}
                        </NavLink>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        {caseItem.contractAttorneyId && caseItem.contractAttorneyFirstName && caseItem.contractAttorneyLastName &&
                            <NavLink to={`user-profile?${caseItem.contractAttorneyId}`} onClick={openLink} >
                                {caseItem.contractAttorneyFirstName + " " + caseItem.contractAttorneyLastName}
                            </NavLink>
                        }
                        {(!caseItem.contractAttorneyId || !caseItem.contractAttorneyFirstName || !caseItem.contractAttorneyLastName) &&
                            <span>No Responsible Attorney</span>
                        }
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        {caseItem.contractLawFirmId && caseItem.contractLawFirmName &&
                            <NavLink to={`user-profile?${caseItem.contractLawFirmId}`} onClick={openLink} >
                                {caseItem.contractLawFirmName}
                            </NavLink>
                        }
                        {(!caseItem.contractLawFirmId || !caseItem.contractLawFirmName) &&
                            <span>No Responsible Law Firm</span>
                        }
                    </StyledTableCell>
                </StyledTableRow>
            ))}
        </TableBody>
    )
}
